import { Injectable } from '@angular/core';
import { AjaxResponse } from 'rxjs/ajax';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseRequester } from '../../../../shared/services/common/base-requester';
import {
    CreateFormRequest,
    GetProductRequest,
    UpsertShortNameRequest,
} from './interfaces/api';

@Injectable({
    providedIn: 'root',
})
export class RequestTaxInvoiceService extends BaseRequester {
    constructor() {
        super();
    }

    upsertShortName(request: UpsertShortNameRequest): Observable<any> {
        return this.request<UpsertShortNameRequest>(
            environment.vcbTaxInvReqUpsertShortNameEndpoint,
            request,
        );
    }

    getProductData(request: GetProductRequest): Observable<any> {
        return this.request<GetProductRequest>(
            environment.vcbTaxInvReqGetProductEndpoint,
            request,
        );
    }

    createForm(request: CreateFormRequest): Observable<any> {
        return this.request<CreateFormRequest>(
            environment.vcbTaxInvReqCreateFormEndpoint,
            request,
        );
    }

    private request<T>(endpoint: string, request: T): Observable<any> {
        return this.internalPostRequest(endpoint, request).pipe(
            map((response: AjaxResponse) => {
                if (!response.response.errorMessage) {
                    return response.response;
                } else {
                    throw new Error(
                        response.response.errorMessage || response.response,
                    );
                }
            }),
        );
    }
}
